






















import Vue from "vue";

export default Vue.extend({
  name: "Button",
  props: {
    text: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      required: true
    },
    inverted: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    clickFunction: {
      type: Function,
      required: true
    },
    icon: {
      type: String,
      required: false
    }
  }
});
